module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ad527cc5.woff";